import { IDs } from '../../../helpers/IDs';
import { DataService } from '../../../services/data_service';
import { TriggerService } from '../../../core/trigger/trigger_service';



export function saveDataKennziffern(values: any, data: any, dataService: DataService,
    triggerService?: TriggerService, callback?: () => void) {
    const saveList: Array<any> = [];    // Array für alle zu speichernden Werte
    const jahr = values.jahr; // Das Jahr gleich holen
    const standort_tid = values.standort_tid_orig || values.standort_tid;
    const werte = data[IDs.ENT_KENNZAHLEN_WERTE];    // Bisherige Werte
    // console.log('WERTE ALT: ', werte);
    let hasValidValue = false;
    Object.keys(values).forEach((kuerzel: string) => {
        if (kuerzel === 'jahr' || kuerzel === 'standort_tid' || kuerzel === 'tid' ||
            kuerzel === '_formKey' || kuerzel === 'abrechnungszeitraum_von' ||
            kuerzel === 'abrechnungszeitraum_bis' || kuerzel === 'standort_tid_orig' ||
            kuerzel === 'standort_tid_name') {   // Hier ignorieren, da keine Kennziffer
            return;
        }
        const wert = values[kuerzel];
        if (wert) {
            hasValidValue = true;
        }
        const kennAlt = werte.find((w: any) => w.jahr === jahr && w.standort_tid_orig === standort_tid &&
            w.kuerzel === kuerzel); // Datensatz anhand Jahr und Kürzel suchen
        if (!kennAlt) { // Gänzlich neuer Datensatz
            saveList.push({ tid: 0, jahr, standort_tid, kuerzel, wert });
        } else {
            if (kennAlt.wert !== wert) {
                kennAlt.wert = (!wert && wert !== 0) ? null : wert;
                kennAlt.standort_tid = standort_tid;
                saveList.push(kennAlt);
            }
        }
    });
    // console.log('SaveList: ', saveList);
    dataService.saveDataList(IDs.ENT_KENNZAHLEN_WERTE, saveList, () => {
        if (triggerService) {
            console.log('RELOAD KENNZIFFERN');
            triggerService.fire('reload', IDs.ENT_KENNZAHLEN_WERTE, callback);   // Reload triggern
        } else {
            console.log('NO RELOAD KENNZIFFERN');
        }
    }, IDs.MOD_ETOOL);
    return hasValidValue;
}

export function delDataKennziffern(row: any, data: any, dataService: DataService, triggerService?: TriggerService, callback?: () => void) {
    const werte = data[IDs.ENT_KENNZAHLEN_WERTE]; // Bisherige Werte
    const jahr = row.jahr;
    const standort_tid = row.standort_tid;
    const delList = werte.filter((w: any) =>
        w.jahr === jahr
        && (w.standort_tid === standort_tid || w.standort_tid_orig === standort_tid)
        && row.hasOwnProperty(w.kuerzel)
        && +row[w.kuerzel] === +w.wert
    );
    if (delList.length > 0) {
        dataService.delDataList(IDs.ENT_KENNZAHLEN_WERTE, delList, () => {
            if (triggerService) {
                triggerService.fire('reload', IDs.ENT_KENNZAHLEN_WERTE, callback); // Reload triggern
            }
        }, IDs.MOD_ETOOL);
    }
}

export function transformWerteKennziffern(werte: Array<any>) {
    const data: any = {};
    let tid = 1;
    // console.log('Transform:', werte);
    werte.forEach((w: any) => {
        const jahr = w.jahr;
        const standort_tid = w.standort_tid;
        const standort_tid_orig = w.standort_tid_orig;
        const wert = w.wert === null ? null :
            isNaN(+w.wert) ? w.wert : +w.wert;
        const kuerzel = w.kuerzel;
        // console.log(kuerzel, w.wert, wert);
        const js_key = jahr + '_' + standort_tid;
        if (!data[js_key]) {
            data[js_key] = { tid, jahr, standort_tid, standort_tid_orig };
            tid++;
        }
        data[js_key][kuerzel] = wert;
    });
    const res = Object.keys(data).map((k: any) => data[k]);
    // console.log('Kennziffern: ', werte, res);
    return res;
}
